import React, { useState, useMemo } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { getPlatformName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';

const Visualis: React.FC<any> = (props: any) => {
  const { chartType = 'line', imageType = 'mobile', lineData, metricSegVal, dateType } = props;

  // console.log('ChannelsCardChannelsCard', props);

  const [chartLoading, setChartLoading] = useState(false);

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any, _platform = '') => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      arr.push({
        metric: _platform,
        source: 'appannie',
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: list[i].value,
      });
    }
    return arr;
  };

  const getMetricsList = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const n in list) {
      const objTemp = {
        cover: list[n].cover,
        id: list[n].app_id,
        name: `${list[n].name}(${getPlatformName(list[n]?.platform)})`,
        history: getRpdTypeData(list[n].history || [], list[n].platform),
      };
      arr.push(objTemp);
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = {};
    for (const n in lineData) {
      arrGameData[lineData[n].metric] = getMetricsList(lineData[n].detail_list);
    }
    return arrGameData;
  }, [lineData]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: metricSegVal,
    topChartsType: 'stats-retentionmonthly-line',
    imageType,
    titleNow: metricSegVal,
    dateType,
  });

  return (
    <>
      <div className="card-line">
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          // isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
